import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import moment from 'moment'

import { USER_BRANCH_QUERY } from '../../queries'
import { DELETE_USER } from '../../mutations'

import Table from '../../components/Table/'
import { Section, Title } from './styles'

import helpers from '../../helpers'

class Branch extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  formatUsers(users) {
    const items = []

    users.map(user => {
      user.insertion = helpers.findInsertion(user.insertion)
      return items.push({
        id: user.id,
        one: user.contactCode,
        two: user.firstName + ' ' + (user.insertion ? user.insertion + ' ' : '') + user.lastName,
        three: user.email,
        four: {
          content: user.username === null ? 'Verstuur activatielink' : (user.loginTimeStamp ? `${moment(user.loginTimeStamp).format('DD-MM-YYYY ')} - ${moment(user.loginTimeStamp).format('HH:mm')}u` : 'Onbekend'),
          link: user.username === null ? `mailto:${user.email}?subject=Activatielink - Kaars Koffie Portal&body=https://portal.kaarskoffie.nl/activeren/${user.id}` : null
        }
      })
    })

    return items
  }

  render() {
    const headers = ['Contactcode', 'Naam', 'E-mailadres', 'Laatste inlog']
    const deleteUserPermission = this.props.deleteUser
    const editUserPermission = this.props.editUser

    return (
      <Section>
        <Title>{this.props.data.name}</Title>
        <Mutation
          mutation={DELETE_USER}
          update={(store, { data: { deleteUser } }) => {
            const data = store.readQuery({ query: USER_BRANCH_QUERY })
            let branchIndex = data.self.branches.findIndex(x => x.id === this.props.data.id)
            let userIndex = data.self.branches[branchIndex].users.findIndex(u => u.id === deleteUser.id)
            data.self.branches[branchIndex].users.splice(userIndex, 1)
            store.writeQuery({
              query: USER_BRANCH_QUERY,
              data
            })
          }}
        >
          {(deleteUser, { data, loading, error }) => {
            const users = this.formatUsers(
              this.props.data.filteredUsers ? this.props.data.filteredUsers : this.props.data.users
            )
            if (users.length > 0) {
              return (
                <Table
                  headers={headers}
                  items={users}
                  fullUsers={this.props.data.filteredUsers ? this.props.data.filteredUsers : this.props.data.users}
                  editable={editUserPermission || deleteUserPermission}
                  editUserPermission={editUserPermission}
                  deleteUserPermission={deleteUserPermission}
                  editType="user"
                  deleteTitle="Weet u zeker dat u deze medewerker wilt verwijderen?"
                  deleteConfirm="Ja, verwijder medewerker"
                  deleteReject="Nee, behoud medewerker"
                  deleteUser={deleteUser}
                  data={data}
                  loading={loading}
                  error={error}
                  currentUser={this.props.currentUser}
                />
              )
            } else {
              return <p>Geen medewerkers gevonden..</p>
            }
          }}
        </Mutation>
      </Section>
    )
  }
}

export default Branch



// WEBPACK FOOTER //
// ./src/components/Branch/index.js